<template>
  <div class="main">
    <div class="nav nav-fill row">
      <div class="nav-item-active col" v-for="item in items" :key="item.id">
        <i class="fa fa-check-circle fa-4x"></i><br>{{item[3]}}
      </div>
      <div class="nav-item-none col" v-for="n in cnt" :key="n">
        <div v-if="n < cnt">
          <i v-if="n < cnt" class="fa fa-circle-thin fa-4x"></i><br>0000.00.00
        </div>
        <div v-if="n == cnt">
          <p class="goal"><i  class="fa fa-circle-thin fa-4x"></i><br><b>GOAL</b></p>
        </div>
      </div>
    </div>
    <dl class="row">
      <dt class="col-2">状態</dt>
      <dd class="col-10 text-left">
          <span v-if="status=='1'" class="pull-left text-muted"><span class="status on">未使用</span></span>
          <span v-if="status=='9'" class="pull-left text-muted"><span class="status off">使用済</span></span>
      </dd>
      <dt class="col-2">特典</dt>
      <dd class="col-10 text-left">
        <p>スタンプが五つたまったら<br>
        次回来店時ﾗﾝﾁﾀｲﾑ・ﾃｲｸｱｳﾄ500円OFF<br>
        又はﾃﾞｨﾅｰﾀｲﾑ1000円OFF!</p>
      </dd>
      <dt class="col-2">条件</dt>
      <dd class="col-10 text-left">
        <p>ﾗﾝﾁ・ﾃﾞｨﾅｰ・ﾃｲｸｱｳﾄ<br>
        ご利用1回スタンプ1回押印<br>
        会計時にお伝えください。</p>
      </dd>
      <dd class="col-12 text-left">
        <p class="text-muted small">
        ※1000円以上のご利用に限ります（お子様ﾗﾝﾁ不可）<br>
        ※他券・他サービス・クレジットカード併用不可<br>
        ※他のお客様とのスタンプの共有はできません<br>
        ※一家族での会計の場合、お食事1回につき1枚ご利用できます（複数不可）<br>
        </p>
        <p>
        <code>ご利用になる際はこの画面をスタッフにお見せください</code>
        <span class="btn btn-warning btn-block" v-on:click="writeoff()" v-if="status=='1'">カードを使用する</span>
        <span class="btn btn-secondary btn-block disabled" v-if="status=='9'">カードを使用する</span>
        </p>
      </dd>
      <dd class="col-12 text-left">
      </dd>
    </dl>
  </div>
</template>
<script>
import sx from '../utils/core.js'
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created () {
    this.$store.state.title = 'スタンプ詳細'
    this.$store.state.showBack = true
    this.$store.state.pageBack = 'StampList'
    this.$store.state.confirmdef = this.confirmdef
  },
  data() {
    return {
      items: [],
      cnt: 0,
      status: '',
      confirmdef: {
        title: 'スタンプカードご利用',
        msg: 'ＯＫボタンを押すと使用済みとなります。<br>継続しますか？',
        cancelText: 'キャンセル',
        okText: 'OK'
      }
    }
  },
  mounted() {
    window.history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.onBrowserBack, false);

    sx.showWaiting()
    const that = this

    var params = {
      corpid: 40,
      stampid: that.$route.query.stampid,
      token: localStorage.getItem('token')
    }
    var url = that.$store.state.baseurl + '/app/mshelper/fetchStampDetails2'
    sx.request(
      url,
      params,
      function(result) {
        if (result.status === 'ok') {
          if (result.data.rows.length == 1 && result.data.rows[0][2] == null) {
            that.items = []
            that.cnt = result.data.rows[0][0]
            that.status = result.data.rows[0][1]
          } else {
            that.items = result.data.rows
            that.cnt = that.items[0][0] - that.items.length
            that.status = result.data.rows[0][1]
          }
          sx.hideWaiting()
        } else if (result.status === 'outdated') {
          that.$router.replace({ name: 'Login' })
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
          sx.hideWaiting()
        }
      },
      function() {
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              if (result.data.rows.length == 1 && result.data.rows[0][2] == null) {
                that.items = []
                that.cnt = result.data.rows[0][0]
                that.status = result.data.rows[0][1]
              } else {
                that.items = result.data.rows
                that.cnt = that.items[0][0] - that.items.length
                that.status = result.data.rows[0][1]
              }
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
              sx.hideWaiting()
            }
          },
          function() {
            console.log("wrong")
          }
        )
      }
    )
  },
  methods: {
    writeoff() {
      const that = this
      $('#myModalConfirm').modal('show')
      $("#confirm").click(function() {
        $('#myModalConfirm').modal('hide')
        if (that.$router.currentRoute.name != "StampDetails") {
          return
        }
        sx.showWaiting()
        var params = {
          stampid: that.$route.query.stampid,
          token: localStorage.getItem('token')
        }
        var url = that.$store.state.baseurl + '/app/mshelper/writeOffStamp'
        sx.request(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              sx.hideWaiting()
              that.status = '9'
              sx.toastSuccess('スタンプカード1枚を使用しました。')
            } else if (result.status === 'err') {
              sx.toastError('スタンプカード使用に失敗しました！')
            } else {
              sx.toastError('アカウントは存在しません！')
            }
          },
          function(result) {
            sx.request(
              url,
              params,
              function(result) {
                if (result.status === 'ok') {
                  sx.hideWaiting()
                  sx.toastSuccess('スタンプカード1枚を使用しました。')
                } else if (result.status === 'err') {
                  sx.toastError('スタンプカード使用に失敗しました！')
                } else {
                  sx.toastError('アカウントは存在しません！')
                }
              },
              function(result) {
                sx.hideWaiting()
                sx.toastError('スタンプカード使用に失敗しました！')
                console.log('recovery failed')
              }
            )
          }
        )
        sx.hideWaiting()
      })
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.onBrowserBack, false);
  }
}
</script>
<style scoped>
.main{
  margin:20px 0 0 0
}
.nav {
  font-size:9pt;
}
.nav .nav-item-active {
  color:#fb6e14;
  margin-bottom:20px;
}
.nav .nav-item-none {
  color:#b2b2b2;
}
.goal {
  color:#b2b2b2
}
.row {
  margin-right:0;
  margin-left:0;
}
.col {
  padding-right:4px;
  padding-left:4px;
}
.status {
  height: 34rpx;
  line-height: 34rpx;
  font-size: 9pt;
  width: 300px;
  text-align: center;
  justify-content: center;
  margin-bottom: 10rpx;
  border-radius: 4px;
  padding: 0 10rpx;
  margin-right: 10rpx;
  background: #CCCCCC;
  color: black;
  margin:2px;
  padding:4px;
}
.ing{
  background: #FF9966;
  color: white;
}
.on {
  background: #99CC66;
  color: white;
}
.off {
  background: #CCCCCC;
  color: black;
}
</style>
